import moment from 'moment';
import { Divider, Space, Typography } from 'antd';
import { BsLightbulbFill } from 'react-icons/bs';
import { AiOutlineWhatsApp } from 'react-icons/ai';
import { Trans, useTranslation } from 'react-i18next';
import ItemData from '../Item';
import { formatPhone } from '../../../utils/bookings';
import { IBooking, IBookingEvent } from '../../../interfaces/booking.interface';
import { useWorkspaceStore } from '../../../store/workspace.store';

interface Props {
    type?: 'SUCCESS' | 'FAILED' | 'RESOLVING'
    booking: IBooking;
    bookingEvent: IBookingEvent;
    deliveryProvider: string;
}

const { Text } = Typography;

const ArrivedAtPickupStatus = ({
    type = 'SUCCESS', booking, bookingEvent, deliveryProvider,
}: Props) => {
    const { t } = useTranslation('bookings', { keyPrefix: 'DETAIL' });
    const workspace = useWorkspaceStore((state) => state.data);

    const providerName = workspace?.name;

    const phoneFormatted = booking?.customerMobile ? formatPhone(booking?.customerMobile, deliveryProvider) : null;

    const date = moment(bookingEvent?.createdAt).format('DD MMM HH:mm');

    return (
        <div className="booking__status--detail">
            <Space direction="vertical" size={4}>
                <Text className="booking__status--detail-title">
                    {t('STORY_LINE.EVENT_DETAILS')}
                </Text>

                <Text className={`booking__status--detail-tag ${type}`}>
                    {t(`STORY_LINE.${type}`)}
                </Text>
            </Space>

            <Text>
                <Trans
                    t={t}
                    i18nKey="STORY_LINE.STATUS.ARRIVED_AT_PICKUP_DESCRIPTION"
                    components={{ b: <b className="booking__status--bold" /> }}
                    values={{
                        driverName: booking?.driverName,
                        deliveryProvider: providerName,
                        businessName: booking.businessName,
                    }}
                />
            </Text>

            <div className="help">
                <div className="help__tag">
                    <BsLightbulbFill />
                    {t('STORY_LINE.REMEMBER')}
                </div>
                <Text>
                    <Trans
                        t={t}
                        i18nKey="STORY_LINE.STATUS.ARRIVED_AT_PICKUP_HELP"
                    />
                </Text>
            </div>

            <Text className="booking__status--time">
                {date}
            </Text>

            <Divider />

            <Text className="booking__status--detail-subtitle">
                {t('STORY_LINE.INFORMATION')}
            </Text>

            <div className="booking__status--detail-info">
                <ItemData
                    label={t('BUSINESS_NAME')}
                    value={booking.businessName || t('NOT_AVAILABLE')}
                />
                <ItemData
                    label={t('CUSTOMER_MOBILE')}
                    value={phoneFormatted}
                    actionRequired={phoneFormatted !== null}
                    actionIcon={(
                        <AiOutlineWhatsApp
                            color="#6C8EEF"
                            size={16}
                            style={{ verticalAlign: 'middle' }}
                        />
                    )}
                    action={phoneFormatted !== null ? () => window.open(`https://wa.me/${phoneFormatted}`, '_blank') : () => {}}
                />
                <ItemData
                    label={t('DRIVER_NAME')}
                    value={booking?.driverName}
                />
            </div>

        </div>
    );
};

export default ArrivedAtPickupStatus;
